import type { SliderProps } from "react-aria-components";
import { Label, Slider, SliderThumb, SliderTrack } from "react-aria-components";
import "./EventSlider.scss";

interface EventSliderProps<T> extends SliderProps<number[]> {
	label?: string;
	tooltipTitle?: string;
}

export function EventSlider<T extends number | number[]>({ label, tooltipTitle, ...props }: EventSliderProps<T>) {
	return (
		<Slider {...props}>
			<Label></Label>
			<SliderTrack>
				{({state}) => state.values.map((_, i) => {
					let property = "left";
					let percent = state.getThumbPercent(i) * 100;

					if (i === 1) {
						property = "right";
						percent = 100 - percent;
					}

					return (
						<div key={i}>
							<div
								className={`react-aria-SliderFill react-aria-SliderFill--${i}`}
								style={{[property]: percent + "%"}}
							/>
							<SliderThumb key={`sliderThumb-${i}`} index={i}/>
						</div>
					)
				})}
			</SliderTrack>
		</Slider>
	);
}
